import { z } from "zod";

/** FR-027: transport-visible milestones, never private model reasoning. */
export const GENERATION_STAGES = ["brief", "storyline", "visual_direction", "assets", "slides", "preflight", "compile", "verify", "package"] as const;
export const generationStageSchema = z.enum(GENERATION_STAGES);
export const generationProgressSchema = z.object({
  projectId: z.string().trim().min(1).max(200),
  operationId: z.uuid(),
  stage: generationStageSchema,
  status: z.enum(["running", "completed", "failed", "interrupted"]),
  completedUnits: z.number().int().nonnegative(),
  totalUnits: z.number().int().positive(),
  completedStages: z.array(generationStageSchema),
  activity: z.enum(["working", "retrying", "validating"]),
  startedAt: z.iso.datetime(),
  stageStartedAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
}).strict().superRefine((value, context) => {
  if (value.completedUnits > value.totalUnits) context.addIssue({ code: "custom", path: ["completedUnits"], message: "Completed units exceed total." });
  if (value.status === "completed" && value.completedUnits !== value.totalUnits) context.addIssue({ code: "custom", message: "Completion requires all units." });
});
export type GenerationStage = z.infer<typeof generationStageSchema>;
export type GenerationProgress = z.infer<typeof generationProgressSchema>;
export type GenerationActivity = GenerationProgress["activity"];
export type GenerationProgressReporter = (stage: GenerationStage, completedUnits?: number, totalUnits?: number, activity?: GenerationActivity) => void;
